import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { ConsensusOkoLogo } from "./ConsensusOkoLogo";
import { ConsensusTransitionOkoAssistant } from "./ConsensusTransitionOkoAssistant";
import { Celebration } from "components/pages/Session/Celebration/Celebration";
import { ScreenTitle } from "components/shared/ScreenTitle/ScreenTitle";
import { colors, constants } from "utils";

export const ConsensusTransitionView = ({ currentTransitionState,
                                          show,
                                          announcePhase,
                                          text,
                                          subtext,
                                          isCelebrating,
                                          surveyData,
                                          onSurveyResponse,
                                          dismissChallengeSurvey,
                                          showStartNewSessionButton }) => {
  const [showChallengeSurvey, setShowChallengeSurvey] = useState(false);

  useEffect(() => {
    if (surveyData?.type === "challenge_survey") {
      setShowChallengeSurvey(false);
      const timeout = setTimeout(() => {
        setShowChallengeSurvey(true);
      }, 1500);
      return () => clearTimeout(timeout);
    } else {
      setShowChallengeSurvey(false);
    }
  }, [surveyData]);

  let color;
  switch (currentTransitionState) {
    case constants.SOLO_TIME:
      color = colors.blue500;
      break;
    case constants.TEAM_TIME:
      color = colors.pink700;
      break;
    default:
      color = colors.blue500;
  }

  const phaseAnnouncement =
    currentTransitionState === constants.SOLO_TIME
      ? `Entering ${constants.SOLO_TIME}`
      : currentTransitionState === constants.TEAM_TIME
        ? `Entering ${constants.TEAM_TIME}`
        : [text, subtext].filter(Boolean).join(" ");

  const startNewSessionButtonStyle = {
    position: "absolute",
    bottom: "8%",
    alignItems: "center",
    backgroundColor: "white",
    border: "none",
    borderRadius: "100px",
    color: colors.pink700,
    display: "flex",
    fontWeight: 500,
    justifyContent: "center",
    padding: "16px 24px",
    width: "240px",
    height: "48px"
  };

  const onStartNewSession = () => {
    window.location.href = process.env.REACT_APP_OKOLABS_APP_URL; // Don't log out here
  };

  return (
    <>
      {/* The visual overlay is suppressed entering Solo Time between questions,
          but the phase change still needs announcing — `announcePhase` keeps the
          screen-reader heading firing when nothing is drawn. */}
      <ScreenTitle name={(show || announcePhase) && !surveyData ? phaseAnnouncement : ""} />
      <div style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: `${show ? "flex" : "none"}`,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: surveyData?.type === "session_survey"
          ? colors.pink700 : surveyData?.type === "challenge_survey" ? (showChallengeSurvey ? "rgba(0, 20, 11, 0.75)" : "transparent") : color,
        zIndex: 100
      }}>
      {!surveyData && (
        <>
          {isCelebrating && <Celebration />}
          <ConsensusOkoLogo color={"white"} />
          <div aria-hidden="true" style={{
            position: "absolute",
            bottom: "8%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "12px"
          }}>
            <p style={{
              color: "white",
              fontSize: "60px",
              fontWeight: 600,
              lineHeight: "110%",
              letterSpacing: 0,
              margin: 0
            }}>{text}</p>
            {subtext && (
              <p style={{
                color: "#6C0D36",
                fontSize: "60px",
                fontWeight: 600,
                lineHeight: "110%",
                letterSpacing: 0,
                margin: 0
              }}>{subtext}</p>
            )}
          </div>
        </>
      )}
      {showStartNewSessionButton && (
        <Button
          onClick={onStartNewSession}
          style={startNewSessionButtonStyle}
          type="submit">
          Start a New Session
        </Button>
      )}
      <ConsensusTransitionOkoAssistant
        eventBackgroundColor={color}
        surveyData={surveyData}
        onSurveyResponse={onSurveyResponse}
        dismissChallengeSurvey={dismissChallengeSurvey}
        showChallengeSurvey={showChallengeSurvey} />
      </div>
    </>
  );
};
